import axios from "axios";

// During development the create react app server runs on a different port to the Django app.
// If we're in local development mode lets set a base URL using the ENV variable.
// If we're not in local dev mode, then we can use relative URLs.
const baseURL = process.env.REACT_APP_BASE_URL || false;
// console.log('process.env.REACT_APP_BASE_URL = ', process.env.REACT_APP_BASE_URL);

// We need to be able to get cookies, because the CSRF token we need to certain requests is in a cookie.
const getCookie = (name) => {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
};

// Get the CSRF token value from the cookie.
const csrftoken = getCookie("csrftoken");

let instanceSettings = {
    "Content-Type": "application/json",
};

// If we've got a baseURL add it to the settings.
if (baseURL) {
    instanceSettings.baseURL = baseURL;
}

// If we're not in development mode then we don't want to use CSRF, otherwise add the token to the settings.
if (process.env.NODE_ENV !== "development") {
    instanceSettings.headers = {
        "X-CSRFToken": csrftoken,
    };
}

// Create a new Axios instance to use that will have the appropriate settings for the env we're in.
const instance = axios.create(instanceSettings);

export default instance;
